import apiClient from "./apiClient";

// 🔹 Get all course units (optionally with filters like ?limit=10)
export const getUnits = async (params = {}) => {
  const response = await apiClient.get("/course_units/", { params });
  return response.data;
};

// 🔹 Get course unit by ID
export const getUnitById = async (id) => {
  const response = await apiClient.get(`/course_units/${id}`);
  return response.data;
};

// 🔹 Create a new course unit
export const createUnit = async (data) => {
  const response = await apiClient.post("/course_units/", data);
  return response.data;
};

// 🔹 Update an existing course unit
export const updateUnit = async (id, data) => {
  const response = await apiClient.put(`/course_units/${id}`, data);
  return response.data;
};

// 🔹 Delete a course unit
export const deleteUnit = async (id) => {
  const response = await apiClient.delete(`/course_units/${id}`);
  return response.data;
};

// ✅ Correct: Get course units belonging to a specific course
export const getUnitsByCourse = async (courseId) => {
  const response = await apiClient.get(`/course_units/by_course/${courseId}`);
  return response.data;
};
